import {
  ContactAddress,
  ContactEmail,
  ContactPhone,
  ProfilePageContextType,
  ProfileInfo,
  ProfilePage,
  ProfilePageError,
  ProfilePageLoading,
} from '../types';
import environment from '../../../../environments/environment';
import { InjectionToken } from '@angular/core';

export const PROFILE_URL = `${environment.irisApi}/user_profile/`;
export const ADMIN_PROFILE_URL = `${environment.irisApi}/admin/user_profile/`;

export const DEFAULT_PROFILE_INFO: ProfileInfo = {
  personalDetails: {
    id: '',
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    prefix: '',
    pronouns: '',
    timeZone: '',
    legacyId: 0,
    npi: '',
    isPi: false,
    email: '',
  },
  role: {
    role: { id: '', label: '' },
    qcFunction: { id: '', label: '' },
    isInternal: null,
  },
  status: '',
  systemIds: {
    userId: '',
    investigatorWcgId: '',
    oktaId: '',
    primaryContactId: '',
    additionalContactIds: '',
  },
};

export const DEFAULT_PROFILE_PAGE_PROPS: ProfilePage = {
  profile: {
    user_id: '',
    contact_id: '',
    organizationId: '',
    contact_version: 0,
    info: DEFAULT_PROFILE_INFO,
    addresses: [],
    specialties: [],
    degrees: [],
    phones: [],
    emails: [],
    total: 0,
  },
  loading: null,
  userUpdatedResult: null,
  error: null,
  isStaff: false
};
export const DEFAULT_PROFILE_PAGE = new InjectionToken<ProfilePage>(
  'Default Profile Page',
  {
    factory: () => ({ ...DEFAULT_PROFILE_PAGE_PROPS }),
  },
);

/**
 * @NOTE: Preserve primary address at the top of the list
 * @param addresses
 * @returns
 */
export const getPrimaryAddress = (addresses: ContactAddress[]) => {
  if (!addresses?.length) {
    return [] as ContactAddress[];
  }
  const _primaryAddress = addresses.find((address) => address.is_primary);
  return _primaryAddress
    ? [_primaryAddress, ...addresses.filter((address) => !address.is_primary)]
    : addresses;
};

/**
 * @NOTE: Preserve primary email at the top of the list
 * @param emails
 * @returns
 */

export const getPrimaryEmail = (emails: ContactEmail[]) => {
  if (!emails?.length) {
    return [] as ContactEmail[];
  }
  const _primaryEmail = emails.find((email) => email.is_primary);
  return _primaryEmail
    ? [_primaryEmail, ...emails.filter((email) => !email.is_primary)]
    : emails;
};

/**
 * @NOTE: Preserve primary phones at the top of the list
 * @param phones
 * @returns
 */
export const getPrimaryPhones = (phones: ContactPhone[]) => {
  if (!phones?.length) {
    return [] as ContactPhone[];
  }
  const _primaryPhone = phones.find((phone) => phone.is_primary);
  return _primaryPhone
    ? [_primaryPhone, ...phones.filter((phone) => !phone.is_primary)]
    : phones;
};

export const setProfilePageError = (
  type: ProfilePageContextType,
  error: Error | null,
): ProfilePageError => {
  return {
    type: type,
    error: error,
  };
};

export const setProfilePageLoading = (
  type: ProfilePageContextType,
  isLoading: boolean,
): ProfilePageLoading => {
  return {
    type: type,
    isLoading,
  };
};
